/* eslint-disable frontApplet/enforce-jsdoc */
import { getEnrichedStack, ISosErrorTransferObject } from './errorHelper';
import ErrorCodes from './ErrorCodes';
import ErrorSuggestions from './ErrorSuggestions';

export interface IBaseSosErrorParams {
	message: string;
	code: ErrorCodes;
	type?: string;
	suggestion?: ErrorSuggestions;
}

export interface IBaseSosErrorParamsWithDocs extends IBaseSosErrorParams {
	pathToDocs?: string;
}

export interface ISosErrorParams extends IBaseSosErrorParamsWithDocs {
	kind: 'sosError';
}

export default class SosError extends Error {
	public code: ErrorCodes;
	public suggestion?: ErrorSuggestions;
	public pathToDocs?: string;

	constructor({ message, code, suggestion, pathToDocs, type }: ISosErrorParams) {
		super(message);
		this.name = type ? type : 'SosError';
		this.code = code;
		this.suggestion = suggestion;
		this.pathToDocs = pathToDocs;
		this.stack = getEnrichedStack({
			type: this.name,
			message,
			code,
			stackTrace: this.stack,
			suggestion,
			pathToDocs,
		} as ISosErrorTransferObject);
	}
}
